__turbopack_context__.v({
  "buckleCard": "BuckleSelector-module-scss-module__VNdQ8a__buckleCard",
  "buckleMaterial": "BuckleSelector-module-scss-module__VNdQ8a__buckleMaterial",
  "buckleName": "BuckleSelector-module-scss-module__VNdQ8a__buckleName",
  "bucklePrice": "BuckleSelector-module-scss-module__VNdQ8a__bucklePrice",
  "checkmark": "BuckleSelector-module-scss-module__VNdQ8a__checkmark",
  "container": "BuckleSelector-module-scss-module__VNdQ8a__container",
  "grid": "BuckleSelector-module-scss-module__VNdQ8a__grid",
  "header": "BuckleSelector-module-scss-module__VNdQ8a__header",
  "image": "BuckleSelector-module-scss-module__VNdQ8a__image",
  "imageWrapper": "BuckleSelector-module-scss-module__VNdQ8a__imageWrapper",
  "info": "BuckleSelector-module-scss-module__VNdQ8a__info",
  "integrated": "BuckleSelector-module-scss-module__VNdQ8a__integrated",
  "integratedInfo": "BuckleSelector-module-scss-module__VNdQ8a__integratedInfo",
  "integratedLabel": "BuckleSelector-module-scss-module__VNdQ8a__integratedLabel",
  "integratedNote": "BuckleSelector-module-scss-module__VNdQ8a__integratedNote",
  "placeholderImage": "BuckleSelector-module-scss-module__VNdQ8a__placeholderImage",
  "placeholderText": "BuckleSelector-module-scss-module__VNdQ8a__placeholderText",
  "selected": "BuckleSelector-module-scss-module__VNdQ8a__selected",
  "selectedBadge": "BuckleSelector-module-scss-module__VNdQ8a__selectedBadge",
  "subtitle": "BuckleSelector-module-scss-module__VNdQ8a__subtitle",
  "title": "BuckleSelector-module-scss-module__VNdQ8a__title",
  "unavailable": "BuckleSelector-module-scss-module__VNdQ8a__unavailable",
});
